import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

export const LumarDesignPreset = definePreset(Aura, {
  semantic: {
    lumar: {
      'lumar-gray': '#20333F',
      'lumar-blue': '#054696',
      'lumar-gray-70': '#58666FB3',
      'lumar-gray-50': '#90999F80'
    },
    iconSize: '24px'
  },
  components: {
    button: {
      colorScheme: {
        light: {
          root: {
            primary: {
              background: '{lumar.lumar-blue}',
              hoverBackground: '{lumar.lumar-blue}',
              activeBackground: '{lumar.lumar-blue}',
              borderColor: '{lumar.lumar-blue}',
              hoverBorderColor: '{lumar.lumar-blue}',
              activeBorderColor: '{lumar.lumar-blue}'
            }
          },
          text: {
            primary: {
              activeBackground: '#F8F8F9',
              hoverBackground: '#F8F8F9',
              color: '#054696'
            },
            secondary: {
              activeBackground: '#F8F8F9',
              hoverBackground: '#F8F8F9',
              color: '#ffffff'
            }
          }
        }
      },
      root: {
        borderRadius: '40px',
        paddingX: '24px',
        paddingY: '14px',
        lg: {
          fontSize: '24px',
          iconOnlyWidth: '48px'
        },
        sm: {
          iconOnlyWidth: '24px'
        }
      }
    },
    inputtext: {
      root: {
        borderColor: '{lumar.lumar-gray-70}',
        hoverBorderColor: '{lumar.lumar-gray-70}',
        focusBorderColor: '{lumar.lumar-gray-70}',
        color: '{lumar.lumar-gray}',
        placeholderColor: '{lumar.lumar-gray-50}',
        paddingX: '12px',
        paddingY: '11px',
        borderRadius: '6px'
      }
    },
    iconfield: {
      icon: {
        color: '{lumar.lumar-gray-70}'
      }
    }
  }
});

export const primeVueOptions = {
  ripple: true,
  theme: {
    preset: LumarDesignPreset,
    options: {
      darkModeSelector: false,
      options: {
        cssLayer: {
          name: 'primevue',
          order: 'theme, base, primevue'
        }
      }
    }
  }
};
